(function () {
  var root = document.getElementById('cb-cn');
  if (!root) return;
  var notice = root.querySelector('.cb-cn__notice'), settings = root.querySelector('.cb-cn__settings');
  var state = root.querySelector('[data-cb-cn-state]'), toggle = root.querySelector('[data-cb-cn-toggle]');
  var rec = function () { return window.cbRec; };
  function seen() { try { return localStorage.getItem('cb-notice') === '1'; } catch (e) { return false; } }
  function remember() { try { localStorage.setItem('cb-notice', '1'); } catch (e) {} }
  function show(panel) {
    notice.hidden = panel !== notice;
    settings.hidden = panel !== settings;
    root.hidden = false;
    document.documentElement.classList.add('cb-cn-on');
    document.documentElement.style.setProperty('--cb-cn-h', root.offsetHeight + 'px');
  }
  function hide() {
    root.hidden = true;
    document.documentElement.classList.remove('cb-cn-on');
  }
  function paint() {
    var r = rec(), on = r && r.on();
    state.textContent = r && r.eu ? state.dataset.eu : on ? state.dataset.on : state.dataset.off;
    toggle.hidden = !r || r.eu;
    toggle.textContent = on ? toggle.dataset.on : toggle.dataset.off;
  }
  var SECONDS = +root.dataset.seconds || 10, left = SECONDS * 1000, started = 0, timer = 0;
  function leave() {
    go();
    root.classList.add('is-leaving');
    setTimeout(function () { hide(); root.classList.remove('is-leaving', 'is-timing', 'is-paused'); }, 400);
  }
  function run() {
    started = Date.now();
    root.style.setProperty('--cb-cn-t', left + 'ms');
    root.classList.remove('is-paused');
    void root.offsetWidth;
    root.classList.add('is-timing');
    timer = setTimeout(leave, left);
  }
  function pause() {
    if (!timer || notice.hidden) return;
    clearTimeout(timer); timer = 0;
    left = Math.max(1500, left - (Date.now() - started));
    var bar = root.querySelector('.cb-cn__timer'), k = getComputedStyle(bar).transform;
    root.classList.add('is-paused'); root.classList.remove('is-timing');
    bar.style.transform = k === 'none' ? '' : k;
  }
  function resume() {
    if (timer || notice.hidden || root.hidden) return;
    var bar = root.querySelector('.cb-cn__timer'); bar.style.transform = '';
    run();
  }
  ['mouseenter', 'focusin'].forEach(function (t) { root.addEventListener(t, pause); });
  ['mouseleave', 'focusout'].forEach(function (t) { root.addEventListener(t, resume); });
  root.querySelector('[data-cb-cn-ok]').addEventListener('click', function () { clearTimeout(timer); timer = 0; go(); hide(); });
  root.querySelector('[data-cb-cn-close]').addEventListener('click', function () { remember(); hide(); });
  toggle.addEventListener('click', function () { var r = rec(); if (r) { r.set(!r.on()); paint(); } });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cb-cookie-settings]');
    if (!a) return;
    e.preventDefault();
    paint();
    show(settings);
    toggle.hidden ? root.querySelector('[data-cb-cn-close]').focus() : toggle.focus();
  });
  var r = rec();
  if (!r || r.eu || seen() || root.dataset.cart) return;
  function go() { var x = rec(); if (x && x.go) x.go(); }
  function armed() {
    var once = function (e) {
      if (!e.isTrusted || (e.type === 'scroll' && e.target !== document)) return;
      ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (t) { window.removeEventListener(t, once, true); });
      go();
    };
    ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (t) { window.addEventListener(t, once, { capture: true, passive: true }); });
  }
  function start() { if (seen()) return; remember(); show(notice); run(); armed(); }
  function idle() { 'requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 4000 }) : setTimeout(start, 2000); }
  document.readyState === 'complete' ? idle() : window.addEventListener('load', idle, { once: true });
})();

